module.exports = __webpack_public_path__ + "img/bgd3x.ab43fdf2.png";